window.articleList = {
    $articleListWrapper: null,
    $articleListCollapse: null,
    $articles: null,

    init: function($wrapper) {
        this.$articleListWrapper = $wrapper;
        this.$articles = this.$articleListWrapper.querySelectorAll(".teaser");

        setTimeout(function () {
            window.articleTeaser.init(window.articleList.$articles);
        },200);

        if(this.$articleListWrapper.querySelector(".article__collapse")) {
            this.$articleListCollapse = this.$articleListWrapper.querySelector(".article__collapse");
            this.initializeListenerOnCollapse();
        }
    },

    /**
     * Initialize Collapse Function
     */
    initializeListenerOnCollapse: function() {
        this.$articleListCollapse.addEventListener("click", function () {
            if(this.classList.contains("article__collapse--active")) {
                window.articleTeaser.showOrHideDescription(window.articleList.$articles, 'show');
            }
            else {
                window.articleTeaser.showOrHideDescription(window.articleList.$articles, 'hide');
            }

            this.classList.toggle("article__collapse--active");
        });
    }
};
